<template>
    <ModalBase :name="'enviar-' + base.id" title="Enviar deportista" @close="close">
        <ValidationObserver ref="observer" tag="div" class="tw:space-y-4">
            <p class="tw:text-sm tw:text-slate-600">
                Escriba el email donde quiere enviar el deportista
            </p>
            <BaseInputText
                v-model="email"
                label="Email"
                name="Email"
                rules="required|email"
            />
        </ValidationObserver>

        <template #footer>
            <div class="tw:flex tw:justify-end">
                <Button :loading="loading" @click="handleEnviar">
                    ENVIAR
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, getCurrentInstance } from 'vue';
    import { api } from '@/api';
    import { api_routes } from '@/api-routes';
    import { useToast } from '@/composables/common/useToast';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue';
    import Button from '@/modules/admin/ui/Button.vue';

    const props = defineProps({
        base: { type: Object, required: true },
    });

    const emit = defineEmits(['close']);
    const instance = getCurrentInstance();
    const toast = useToast();

    const observer = ref(null);
    const email = ref(props.base.email || '');
    const loading = ref(false);

    const close = () => {
        instance.proxy.$modal.hide('enviar-' + props.base.id);
        emit('close');
    };

    async function handleEnviar() {
        const valid = await observer.value.validate();
        if (!valid) return;

        loading.value = true;
        try {
            const listaId = instance.proxy.$route.params.lista_id;
            const res = await api.call(api_routes['back.bases.enviar'], {
                lista_id: listaId,
                base_id: props.base.id,
                email: email.value,
                filters: {},
            });
            toast.success(res.data.message);
            close();
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Error al enviar el email');
        } finally {
            loading.value = false;
        }
    }
</script>
